import script from "./chatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./chatPage.vue?vue&type=script&setup=true&lang=js"

import "./chatPage.vue?vue&type=style&index=0&id=1df50522&lang=less"
import "./chatPage.vue?vue&type=style&index=1&id=1df50522&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df50522"]])

export default __exports__